<template>
  <div>
    <el-form :model="user" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="头像" prop="head_img">
              <el-upload
                class="avatar-uploader"
                :action="uploadUrl"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="imageUrl" :src="this.GLOBAL.BASE_URL+imageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>

            </el-form-item>
      <el-form-item label="姓名" prop="realname">
        <el-input type="text" v-model="user.realname"></el-input>
      </el-form-item>
      <el-form-item label="专业" prop="major_name">
        <el-input type="text" v-model="user.major_name" disabled></el-input>
      </el-form-item>
      <el-form-item label="年级" prop="grade_name">
        <el-input type="text" v-model="user.grade_name" disabled></el-input>
      </el-form-item>
      <el-form-item label="班级" prop="class_name">
        <el-input type="text" v-model="user.class_name" disabled></el-input>
      </el-form-item>
      <el-form-item label="生日" prop="birthday">
        <el-date-picker
          v-model="user.birthday"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">修改</el-button>
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>

    </el-form>

  </div>

</template>
<script>
    export default {
        name: 'MyInfo',
        inject: ['reload'],
        data() {
            var validateUsername = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('真实姓名不能为空'));
                } else {
                    callback();
                }
            };
            return {
                imageUrl: '',
                ruleForm: {
                    realname: '',
                },
                rules: {
                    realname: [
                        {validator: validateUsername, trigger: 'blur'}
                    ],
                },
                user: {},
                uploadUrl: this.GLOBAL.BASE_URL + '/api/common/upload_file'
            };
        },
        methods: {
            getUserInfo() {
                this.$http.getUserInfo().then(res => {
                  if(res.data!=null){
 this.user = res.data;
                    this.imageUrl = res.data.head_img;
                  }
                   
                })
            },
            handleAvatarSuccess(res, file) {
                this.user.head_img = res.data;
                console.log(this.user)
                this.imageUrl = res.data
            },
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!');
                }
                return isLt2M;
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$http.updateUserInfo(this.user).then(res => {
                            if (res.code !== 0) {
                                this.$store.commit('SetUserInfo', this.user);
                                this.$message.success(res.message);
                                this.reload()
                            }else {
                                this.$message.error(res.message)
                            }
                        })
                    } else {
                        this.$message.error('服务器内部错误!!');
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
        },
        created() {
            this.getUserInfo();
        }
    }
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/USer/MyInfo.vue